import React from 'react';
import PdfViewer from '../components/PdfViewer';
import './DashboardView.css';
import './Sivert.css';
import KidBalance from '../components/Economy/KidBalance';

function Sivert() {
    var timestamp = new Date().getTime();
    var url = `https://kvalstadfamlylifestorage.blob.core.windows.net/sivertstorage/ukeplan.pdf?t=${timestamp}`;
    return (
        <div className="sivertgrid-container">
            <div className="sivertgrid-item sivertgrid-item1" id="ukeplanId">
                <PdfViewer parentId="ukeplanId" file={url} />
            </div>
            <div className="sivertgrid-item sivertgrid-item2">
                <KidBalance kidName='Sivert' />
            </div>
        </div>
    );
}

export default Sivert;